'use client';

import { Box, Flex, BoxProps } from '@mezzoforte/forge';
import { ComponentProps } from 'react';

export const containerWidth = '1800px';

export function Container(props: BoxProps) {
  return (
    <Box
      sx={{
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: containerWidth,
        width: '100%',
        padding: {
          base: '0 1rem',
          md: '0 1.5rem',
          lg: '0 2.5rem',
        },
      }}
      {...props}
    />
  );
}

export function HorizontalScrollContainer(props: BoxProps) {
  return (
    <Container
      sx={{
        marginLeft: {
          base: 0,
          md: 'auto',
        },
        marginRight: {
          base: 0,
          md: 'auto',
        },
        maxWidth: containerWidth,
        width: '100%',
        padding: {
          base: 0,
          md: '0 1.5rem',
          lg: '0 2.5rem',
        },
      }}
      {...props}
    />
  );
}

export function HeroContainer(props: ComponentProps<typeof Flex>) {
  return (
    <Flex
      sx={{
        color: 'white',
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: containerWidth,
        width: '100%',
        height: '100%',
        padding: {
          md: '1.5rem 1.5rem 0',
          lg: '2rem 2.5rem 0',
        },
      }}
      {...props}
    />
  );
}
